export default __webpack_public_path__ + "assets/webgl/scene-26.b919ce0e.glb";